
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("eIoxH", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.7bd4e81c.js.map
